var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4303 51.4606C39.9626 50.9458 50.5023 39.2174 49.9715 25.2644C49.4407 11.3114 38.0404 0.417543 24.5081 0.932339C10.9759 1.44713 0.43616 13.1756 0.966962 27.1286C1.49776 41.0816 12.8981 51.9754 26.4303 51.4606Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4286 51.4603C36.031 51.0951 43.3849 39.4878 42.8541 25.5348C42.3233 11.5818 34.1088 0.566747 24.5064 0.93204C14.9041 1.29733 7.55017 12.9046 8.08098 26.8576C8.61178 40.8106 16.8263 51.8256 26.4286 51.4603Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4298 51.4606C30.8178 51.2937 33.9447 39.8472 33.4139 25.8942C32.8831 11.9412 28.8956 0.765388 24.5075 0.932319C20.1195 1.09925 16.9926 12.5457 17.5234 26.4987C18.0542 40.4517 22.0417 51.6276 26.4298 51.4606Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.961182 27.1286L49.9705 25.2642",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2917 12.8883L3.68848 14.509",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4303 51.4606C39.9626 50.9458 50.5023 39.2174 49.9715 25.2644C49.4407 11.3114 38.0404 0.417543 24.5081 0.932339C10.9759 1.44713 0.43616 13.1756 0.966962 27.1286C1.49776 41.0816 12.8981 51.9754 26.4303 51.4606Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4286 51.4603C36.031 51.0951 43.3849 39.4878 42.8541 25.5348C42.3233 11.5818 34.1088 0.566747 24.5064 0.93204C14.9041 1.29733 7.55017 12.9046 8.08098 26.8576C8.61178 40.8106 16.8263 51.8256 26.4286 51.4603Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4298 51.4606C30.8178 51.2937 33.9447 39.8472 33.4139 25.8942C32.8831 11.9412 28.8956 0.765388 24.5075 0.932319C20.1195 1.09925 16.9926 12.5457 17.5234 26.4987C18.0542 40.4517 22.0417 51.6276 26.4298 51.4606Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.961182 27.1286L49.9705 25.2642",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2917 12.8883L3.68848 14.509",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6394 39.5056L47.2427 37.8849",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.1e07c5562da1d54adc4603c2b4f050e1.svg";
export { ForwardRef as ReactComponent };